if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this == null) {
      throw new TypeError("Array.prototype.find called on null or undefined");
    }
    if (typeof predicate !== "function") {
      throw new TypeError("predicate must be a function");
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

import Vue from "vue";
import Vuex from "vuex";
import VueCookies from 'vue-cookies'
import App from "./App";
import Main from "./Main.vue";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import { store } from "./services/store";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();

Vue.use(Vuex);
Vue.config.productionTip = false;

import VWave from "v-wave";
Vue.use(VWave);

import VueMask from 'v-mask'
Vue.use(VueMask);

import VueRouter from 'vue-router'
Vue.use(VueRouter)

Vue.use(VueCookies, { expires: 31536000})

Vue.config.ignoredElements = [
  'sell-price-widget',
]

Raven.config('https://3527a0b5180d166cdd3936157d795b7d@sentry.securewebsystems.net/82')
  .addPlugin(RavenVue, Vue)
  .install();
  

import Router from './router';

new Vue({
  el: '#app',
  router: Router,
  store: new Vuex.Store(store),
  render: h => h(Main)
})



// WEBPACK FOOTER //
// ./src/main.js